
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/car-accreditation",
      function () {
        return require("private-next-pages/services/car-accreditation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/car-accreditation"])
      });
    }
  